<template>
  <v-card class="rounded-card ma-2" flat outlined>
    <v-card-title>{{ $t('models.dashboard.attributes.violationDetails') }}</v-card-title>
    <v-data-table
      class="violations-table"
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      fixed-header
      hide-default-footer
      height="500px"
      :no-data-text="$t('messages.emptyState', { entity: 'Violations' })"
      :no-results-text="$t('messages.emptyState', { entity: 'Violations' })"
      flat
    >
      <template v-slot:item.date="{ item }">
        {{ formatDate(item.date) }}
      </template>
      <template v-slot:item.expectedTime="{ item }">
        {{ item.expectedTime || '-' }}
      </template>
      <template v-slot:item.actualTime="{ item }">
        {{ item.actualTime || '-' }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  name: 'ViolationsTable',
  props: {
    attendanceItems: {type: Array, required: true}
  },
  computed: {
    items() {
      const records = Array.isArray(this.attendanceItems) ? this.attendanceItems : [];
      return records.flatMap((record) =>
        (record.violations || []).map((violation) => ({
          fullName: record.fullName,
          ...violation
        }))
      );
    },
    headers() {
      return [
        {text: this.$t('models.dashboard.attributes.employee'), value: 'fullName'},
        {text: this.$t('models.dashboard.attributes.date'), value: 'date'},
        {text: this.$t('models.dashboard.attributes.type'), value: 'type'},
        {text: this.$t('models.dashboard.attributes.expectedTime'), value: 'expectedTime'},
        {text: this.$t('models.dashboard.attributes.actualTime'), value: 'actualTime'}
      ];
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
  }
};
</script>


